import React from 'react';
import NavbarSeven from '../components/NavbarSeven';
import BannerEight from '../components/BannerEight';
import ServiceAreaSeven from '../components/ServiceAreaSeven';
import WhyChoose from '../components/WhyChoose';
import ProjectAreaThree from '../components/ProjectAreaThree';
import WorkProcessSeven from '../components/WorkProcessSeven';
import SolutionOne from '../components/SolutionOne';
import TeamAreaFive from '../components/TeamAreaFive';
import ContactAreaSix from '../components/ContactAreaSix';
import TestimonialSeven from '../components/TestimonialSeven';
import BlogAreaEight from '../components/BlogAreaEight';
import FooterSeven from '../components/FooterSeven';

const HomeEight = () => {
  return (
    <>
      {/* Navigation Bar */}
      <NavbarSeven />

      {/* Banner Eight */}
      <BannerEight />

      {/* Service Area Seven */}
      <ServiceAreaSeven />

      {/* Why Choose */}
      <WhyChoose />

      {/* Project Area Three */}
      <ProjectAreaThree />

      {/* Work Process Seven */}
      <WorkProcessSeven />

      {/* SolutionOne */}
      <SolutionOne />

      {/* TeamAreaFive */}
      <TeamAreaFive />

      {/* ContactAreaSix */}
      <ContactAreaSix />

      {/* TestimonialSeven */}
      <TestimonialSeven />

      {/* BlogAreaEight */}
      <BlogAreaEight />

      {/* FooterSeven */}
      <FooterSeven />
    </>
  );
};

export default HomeEight;
